<template lang="pug">
div(v-if='list')
  span(v-if='fieldLabel') {{ fieldLabel }}
  el-select(
    :clearable='clearable'
    :filterable='filterable'
    :placeholder="placeholder"
    v-model='itemSelecionado'
    @change='$emit("input", $event)'
    no-match-text='Nenhum registro encontrado'
    style='margin-top : 5px;'
  )
    el-option(
      v-for="item in list"
      :key="item[chave]"
      :label="item[label]"
      :value="item[chave]"
    )
</template>

<script>
export default {
    name: 'SelectFilterComponent',
    props: {
        value: { required: false },
        list: {
            type: Array,
            required: true,
        },
        fieldLabel: {
            type: String,
            required: false,
        },
        label: {
            type: String,
            required: true,
        },
        chave: {
            type: String,
            default: 'id',
        },
        placeholder: {
            type: String,
            default: 'Selecione',
        },
        filterable: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            itemSelecionado: this.value || null,
        };
    },
    watch: {
        value(newVal) {
            this.itemSelecionado = newVal;
        },
        itemSelecionado(newVal) {
            this.$emit('input', newVal);
        },
    },
};
</script>

<style>
.el-input--suffix .el-input__inner {
    border: 2px solid var(--primary-light-green) !important;
    height: 32px;
    color: var(--primary-green);
    font-size: 13px;
}

.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input__inner,
.el-select .el-input__inner:focus {
    border-color: var(--primary-green);
}

.el-select {
    width: 100%;
}

.el-select:hover .el-input__inner,
.el-input__inner:focus {
    border: 2px solid var(--primary-green) !important;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
    color: var(--primary-green);
    background-color: var(--primary-light-green);
}

.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner,
.el-select-dropdown__item.selected,
.el-select .el-input .el-select__caret {
    color: var(--primary-green);
}

.el-select-dropdown__item {
    color: var(--primary-green);
    background-color: #f5f5f5;
    font-size: 14px;
    font-family: Helvetica, sans-serif;
}

.el-scrollbar {
    border: 1px solid var(--primary-green);
    border-radius: 6px;
}

.el-popper[x-placement^='bottom'] .popper__arrow {
    display: none;
}

.el-select-dropdown__empty {
    color: var(--primary-green);
    background-color: #f5f5f5;
    border: 1px solid var(--primary-green);
    border-top: 0px;
}

.el-select-dropdown__list {
    padding: 0px;
}

.el-popper[x-placement^='bottom'] {
    margin: 0px;
}

.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input .el-select__caret {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
